import { render } from "./SmsSettings.vue?vue&type=template&id=015f8fae&ts=true"
import script from "./SmsSettings.vue?vue&type=script&lang=ts"
export * from "./SmsSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__